const ET_ZONE = 'America/New_York'

const etParts = () => {
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: ET_ZONE,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
  const parts = Object.fromEntries(fmt.formatToParts(new Date()).map((p) => [p.type, p.value]))
  const hour = parts.hour === '24' ? 0 : Number(parts.hour)
  return { weekday: parts.weekday, minutes: hour * 60 + Number(parts.minute) }
}

const SESSIONS = {
  closed: { key: 'closed', label: 'Market Closed', tone: 'neutral', live: false },
  premarket: { key: 'premarket', label: 'Pre-Market', tone: 'caution', live: true },
  regular: { key: 'regular', label: 'Regular Hours', tone: 'bull', live: true },
  afterhours: { key: 'afterhours', label: 'After-Hours', tone: 'caution', live: true },
  overnight: { key: 'overnight', label: 'Overnight', tone: 'neutral', live: true },
}

export const marketSession = () => {
  const { weekday, minutes } = etParts()
  const isWeekend = weekday === 'Sat' || weekday === 'Sun'

  if (isWeekend) return SESSIONS.closed
  if (minutes >= 240 && minutes < 570) return SESSIONS.premarket
  if (minutes >= 570 && minutes < 960) return SESSIONS.regular
  if (minutes >= 960 && minutes < 1200) return SESSIONS.afterhours
  return SESSIONS.overnight
}
